import { ArrowLeft, ArrowRight } from 'lucide-react';

import { useWizardState } from './useWizardState';
import { WizardShell } from './WizardShell';
import styles from './wizard.module.css';

const STEPS = ['ברוך הבא', 'פרטי העסק', 'לוקליזציה', 'סיכום'];

const LOCALE_DEFAULTS = [
  { label: 'אזור זמן', value: 'Asia/Jerusalem' },
  { label: 'שפה', value: 'עברית · he-IL' },
  { label: 'מטבע', value: 'ILS · ₪' },
  { label: 'פורמט תאריך', value: 'DD/MM/YYYY' },
];

export function Step3Locale() {
  const next = useWizardState((s) => s.next);
  const prev = useWizardState((s) => s.prev);

  return (
    <WizardShell
      step={2}
      steps={STEPS}
      foot={
        <>
          <button type="button" className={styles.btnSecondary} onClick={prev}>
            <ArrowRight size={14} className="flip-rtl" />
            חזור
          </button>
          <button type="button" className={styles.btnPrimary} onClick={next}>
            המשך
            <ArrowLeft size={14} className="flip-rtl" />
          </button>
        </>
      }
    >
      <h3>לוקליזציה</h3>
      <p className={styles.help}>
        ערכי ברירת מחדל לישראל. ניתן לשנות בהגדרות הארגון בהמשך.
      </p>

      <div className={styles.localeGrid}>
        {LOCALE_DEFAULTS.map((row) => (
          <div key={row.label} className={styles.localeRow}>
            <span className={styles.localeLabel}>{row.label}</span>
            <span className={styles.localeValue}>{row.value}</span>
          </div>
        ))}
      </div>

      <p className={styles.localeNote}>שדות אלה יהיו ניתנים לעריכה אחרי הגדרת הארגון.</p>
    </WizardShell>
  );
}
